import { useEffect } from "react";
import { useTypewriter } from "../../hooks/useTypewriter";

type TypewriterTextProps = {
  id?: string;
  text: string;
  active: boolean;
  reducedMotion: boolean;
  variant: "headline" | "subhead";
  showCursor?: boolean;
  onDone?: (done: boolean) => void;
};

export const TypewriterText = ({
  id,
  text,
  active,
  reducedMotion,
  variant,
  showCursor = true,
  onDone,
}: TypewriterTextProps) => {
  const typewriter = useTypewriter({
    from: "",
    to: text,
    active: active && !reducedMotion,
    delay: 0,
    pauseMs: 0,
  });

  const displayText = active && !reducedMotion ? typewriter.text : text;

  useEffect(() => {
    if (!active) return;
    if (reducedMotion) {
      onDone?.(true);
      return;
    }
    if (typewriter.isDone) {
      onDone?.(true);
    }
  }, [active, reducedMotion, typewriter.isDone, onDone]);

  const lines = displayText.split("\n").map((line, lineIndex, allLines) => (
    <span key={`${variant}-line-${lineIndex}`}>
      {line}
      {lineIndex < allLines.length - 1 ? <br /> : null}
    </span>
  ));

  if (variant === "headline") {
    return (
      <h2 id={id} className="scroll-chapter__headline">
        {lines}
        {showCursor && active && !reducedMotion && typewriter.isAnimating && (
          <span className="scroll-chapter__cursor" aria-hidden="true" />
        )}
      </h2>
    );
  }

  return <p className="scroll-chapter__subhead">{lines}</p>;
};
